import { render, staticRenderFns } from "./orderWxSalesShenpi.vue?vue&type=template&id=58d35875&scoped=true"
import script from "./orderWxSalesShenpi.vue?vue&type=script&lang=js"
export * from "./orderWxSalesShenpi.vue?vue&type=script&lang=js"
import style0 from "./orderWxSalesShenpi.vue?vue&type=style&index=0&id=58d35875&prod&scoped=true&lang=css"
import style1 from "./orderWxSalesShenpi.vue?vue&type=style&index=1&id=58d35875&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d35875",
  null
  
)

export default component.exports